var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread-box"},[_c('a-breadcrumb',_vm._l((_vm.breadcrumbList),function(str){return _c('a-breadcrumb-item',{key:str},[_vm._v(_vm._s(str))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }